import { z } from 'zod'

// ─── Employee Create Schema (POST /employees) ──────────────────────────────

export const employeeCreateSchema = z.object({
	displayName: z.string().min(1, 'Display name is required'),
	firstName: z.string().min(1).optional(),
	lastName: z.string().min(1).optional(),
	entraDirectoryId: z.uuid().nullable().optional(),
	contractTypeId: z.uuid().nullable().optional(),
	geoLocationId: z.uuid().nullable().optional(),
	departmentId: z.uuid().nullable().optional(),
	leadershipTypeId: z.uuid().nullable().optional(),
	personTypeId: z.uuid().nullable().optional(),
	contractorId: z.uuid().nullable().optional(),
	managerId: z.uuid().nullable().optional(),
	comment: z.string().optional(),
})

export type EmployeeCreateInput = z.infer<typeof employeeCreateSchema>

// ─── Employee Update Schema (PUT /employees/:id) ───────────────────────────

export const employeeUpdateSchema = z.object({
	displayName: z.string().min(1).optional(),
	firstName: z.string().min(1).nullable().optional(),
	lastName: z.string().min(1).nullable().optional(),
	entraDirectoryId: z.uuid().nullable().optional(),
	contractTypeId: z.uuid().nullable().optional(),
	geoLocationId: z.uuid().nullable().optional(),
	departmentId: z.uuid().nullable().optional(),
	leadershipTypeId: z.uuid().nullable().optional(),
	personTypeId: z.uuid().nullable().optional(),
	contractorId: z.uuid().nullable().optional(),
	managerId: z.uuid().nullable().optional(),
	isActive: z.boolean().optional(),
	comment: z.string().optional(),
})

export type EmployeeUpdateInput = z.infer<typeof employeeUpdateSchema>
